/**
 * @generated SignedSource<<0e77e42716a20e04896c9a68bb40527c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FeatureToggleDataKind = "abandonedCartReminder" | "courseRecommendations" | "experimentalMode" | "inProductExpressCheckout" | "noConsentOrderAttribution" | "paymentProviderInvoiceNotice" | "profileEnrichmentSetName" | "scheduledGlobalDiscount" | "secciDownloadCheckout" | "signupMarketingOptIn" | "splitCourseCertification" | "storyblokCampaigns" | "timeBasedLicenses";
export type permissionBasedNavigation_featureToggles_Query$variables = {};
export type permissionBasedNavigation_featureToggles_Query$data = {
  readonly FeatureToggle: {
    readonly activeFeatureToggles: ReadonlyArray<FeatureToggleDataKind>;
  };
};
export type permissionBasedNavigation_featureToggles_Query = {
  response: permissionBasedNavigation_featureToggles_Query$data;
  variables: permissionBasedNavigation_featureToggles_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FeatureToggleQueries",
    "kind": "LinkedField",
    "name": "FeatureToggle",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeFeatureToggles",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "permissionBasedNavigation_featureToggles_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "permissionBasedNavigation_featureToggles_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "cac0e08c80a9b81fa9a1cd26c8bd44b7",
    "id": null,
    "metadata": {},
    "name": "permissionBasedNavigation_featureToggles_Query",
    "operationKind": "query",
    "text": "query permissionBasedNavigation_featureToggles_Query {\n  FeatureToggle {\n    activeFeatureToggles\n  }\n}\n"
  }
};
})();

(node as any).hash = "45b21ab5e82f9a5d03425751f3f670f4";

export default node;
